import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import botConfiguration from "../../Customization/botConfiguration";
import { useBotConfigStore } from "../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { WidgetCopyrightBox } from "../Styles/StyledScreens";

interface Props {
  // developer?: any;
}

const WidgetCopyright: React.FC<Props> = () => {
  const { botConfig } = useSelector(useBotConfigStore);
  const theme: any = useTheme();

  const branding = (
    <>
      Powered by
      <a href={`https://geta.ai/`} target="_blank" rel="noreferrer">
        {botConfig.config?.remove_branding ? (
          botConfig?.chatbot?.business?.name
        ) : (
          <img src={botConfiguration.FOOTER_LOGO} alt="" />
        )}
      </a>
    </>
  );

  // Off the redesign this renders exactly what it always did: the branding sits
  // straight in the box with no hint row and no wrapper (the wrapper would pick
  // up the box's own `span` rule and restyle "Powered by").
  if (!theme?.industry_style?.enabled) {
    return <WidgetCopyrightBox>{branding}</WidgetCopyrightBox>;
  }

  return (
      <WidgetCopyrightBox>
        <p className="composerHint">
          Press Enter to send · Shift+Enter for new line
        </p>
        <span className="brandingWrap">{branding}</span>
      </WidgetCopyrightBox>
  );
};

export default WidgetCopyright;
